module.exports = __webpack_public_path__ + "img/profile_box_gray_foot_way.dc23ac9e.svg";